"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrementHours = void 0;
var utils_1 = require("@time-input-polyfill/utils");
function decrementHours(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, use = utils.use;
    describe('Hours - Decrement', function () {
        it('Should decrement hours as expected on down key press', function () {
            loadPrimaryInput({ segment: 'hrs12' }).then(function () {
                var a = 7;
                while (a > 0) {
                    use.downArrow().should('have.value', "0".concat(a, ":30 PM")).then(a11yHasExpectedHtml("<p>".concat(a, ".</p>"))).then(hasReturnVal("".concat(a + 12, ":30")));
                    a--;
                }
                use.downArrow().should('have.value', "12:30 PM").then(a11yHasExpectedHtml("<p>12.</p>")).then(hasReturnVal("12:30"));
                var b = 11;
                while (b > 7) {
                    use.downArrow().should('have.value', "".concat((0, utils_1.toLeadingZero)(b), ":30 PM")).then(a11yHasExpectedHtml("<p>".concat(b, ".</p>"))).then(hasReturnVal("".concat(b + 12, ":30")));
                    b--;
                }
            });
        });
    });
}
exports.decrementHours = decrementHours;
